import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import logoWide from '../../assets/logo-wide.png';
import settings from '../../constants/settings';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // The dropdown functionality is handled via CSS :hover

  return (
    <header className="bg-[#FDF6F0] fixed top-0 left-0 right-0 z-50">
      <div className="container mx-auto px-4 flex justify-between items-center h-[90px]">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <img
            src={logoWide}
            alt="Pintar Pilih Kuliah"
            className="h-12 md:h-14"
          />
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex items-center justify-between flex-1 ml-10">
          <nav className="flex space-x-8">
            <Link
              to="/"
              className="font-semibold text-black hover:text-orange-500 transition-colors py-2"
            >
              Beranda
            </Link>

            <div className="relative group">
              <div className="relative">
                <button
                  className="font-semibold text-black group-hover:text-orange-500 transition-colors flex items-center py-2"
                >
                  <span>Layanan</span>
                  <ChevronDown
                    size={16}
                    className="ml-1 transform transition-transform group-hover:rotate-180"
                  />
                </button>
                <div className="absolute bottom-0 left-0 w-full h-0.5 bg-orange-500 scale-x-0 group-hover:scale-x-100 transition-transform duration-200 origin-left"></div>
              </div>
              <div className="absolute top-[calc(100%+1px)] left-0 mt-1 bg-black rounded-md shadow-lg overflow-hidden min-w-[220px] z-50 invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-all duration-200">
                <div className="py-1">
                  <Link
                    to="/services"
                    className="block px-4 py-2 text-[#FDF6F0] hover:bg-neutral-800 transition-colors font-medium"
                  >
                    Semua Layanan
                  </Link>
                  <Link
                    to="/services?category=Konsultasi"
                    className="block px-4 py-2 text-[#FDF6F0] hover:bg-neutral-800 transition-colors font-medium"
                  >
                    Konsultasi
                  </Link>
                  <Link
                    to="/services?category=Webinar"
                    className="block px-4 py-2 text-[#FDF6F0] hover:bg-neutral-800 transition-colors font-medium"
                  >
                    Webinar
                  </Link>
                  <Link
                    to="/services?category=Dokumen"
                    className="block px-4 py-2 text-[#FDF6F0] hover:bg-neutral-800 transition-colors font-medium"
                  >
                    Dokumen
                  </Link>
                  <Link
                    to="/services?category=Legalisasi"
                    className="block px-4 py-2 text-[#FDF6F0] hover:bg-neutral-800 transition-colors font-medium"
                  >
                    Legalisasi
                  </Link>
                  <Link
                    to="/services?category=Bahasa"
                    className="block px-4 py-2 text-[#FDF6F0] hover:bg-neutral-800 transition-colors font-medium"
                  >
                    Bahasa
                  </Link>
                  <Link
                    to="/services?category=Bimbingan%20Belajar"
                    className="block px-4 py-2 text-[#FDF6F0] hover:bg-neutral-800 transition-colors font-medium"
                  >
                    Bimbingan Belajar
                  </Link>
                  <Link
                    to="/services?category=Pendaftaran"
                    className="block px-4 py-2 text-[#FDF6F0] hover:bg-neutral-800 transition-colors font-medium"
                  >
                    Pendaftaran
                  </Link>
                  <Link
                    to="/services?category=Trip%20Edukasi"
                    className="block px-4 py-2 text-[#FDF6F0] hover:bg-neutral-800 transition-colors font-medium"
                  >
                    Trip Edukasi
                  </Link>
                </div>
              </div>
            </div>
            
            <Link
              to="/beasiswa"
              className="font-semibold text-black hover:text-orange-500 transition-colors py-2"
            >
              Beasiswa
            </Link>
            
            <Link
              to="/blog"
              className="font-semibold text-black hover:text-orange-500 transition-colors py-2"
            >
              Blog
            </Link>
            
            <Link
              to="/tentang-kami"
              className="font-semibold text-black hover:text-orange-500 transition-colors py-2"
            >
              Tentang Kami
            </Link>
          </nav>

          {/* CTA Button */}
          <div>
            <a 
              href={settings.wa_consultant_link}
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-2.5 rounded-md bg-orange-500 hover:bg-black text-white font-medium shadow-lg hover:shadow-xl hover:translate-y-[-1px] transition-all"
            >
              Konsultasi Beasiswa GRATIS
            </a>
          </div>
        </div>

        {/* Mobile Menu Button */}
        <div className="lg:hidden">
          <button
            onClick={toggleMenu}
            className="flex items-center p-2 text-gray-900 hover:text-gray-500 focus:outline-none"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden ${
          isMenuOpen ? 'block' : 'hidden'
        } bg-[#FDF6F0]`}
      >
        <div className="container mx-auto px-4 py-2">
          <nav className="flex flex-col space-y-1">
            <Link
              to="/"
              className="font-semibold text-black hover:text-orange-500 transition-colors py-3"
              onClick={() => setIsMenuOpen(false)}
            >
              Beranda
            </Link>

            {/* Mobile Link to Services without dropdown */}
            <Link
              to="/services"
              className="font-semibold text-black hover:text-orange-500 transition-colors py-3"
              onClick={() => setIsMenuOpen(false)}
            >
              Layanan
            </Link>

            <Link
              to="/beasiswa"
              className="font-semibold text-black hover:text-orange-500 transition-colors py-3"
              onClick={() => setIsMenuOpen(false)}
            >
              Beasiswa
            </Link>
            <Link
              to="/blog"
              className="font-semibold text-black hover:text-orange-500 transition-colors py-3"
              onClick={() => setIsMenuOpen(false)}
            >
              Blog
            </Link>
            <Link
              to="/tentang-kami"
              className="font-semibold text-black hover:text-orange-500 transition-colors py-3"
              onClick={() => setIsMenuOpen(false)}
            >
              Tentang Kami
            </Link>

            <div className="py-4">
              <a 
                href={settings.wa_consultant_link}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setIsMenuOpen(false)}
                className="block w-full text-center px-4 py-2 rounded-md bg-orange-500 hover:bg-black text-white font-medium hover:shadow-lg hover:translate-y-[-1px] transition-all"
              >
                Konsultasi Gratis
              </a>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
